import { render, staticRenderFns } from "./ResultsStudent.vue?vue&type=template&id=1a8760c4&scoped=true&"
import script from "./ResultsStudent.vue?vue&type=script&lang=js&"
export * from "./ResultsStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8760c4",
  null
  
)

export default component.exports